import type { PropsWithChildren } from "react"

export function Modal({
  open,
  onClose,
  title,
  description,
  widthClassName = "max-w-lg",
  children,
}: PropsWithChildren<{
  open: boolean
  onClose: () => void
  title: string
  description?: string
  widthClassName?: string
}>) {
  if (!open) return null

  return (
    <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 cursor-default border-0 bg-transparent"
        aria-label="Close modal"
        onClick={onClose}
      />
      <div className={`relative w-full max-h-[calc(100vh-2rem)] flex flex-col overflow-hidden rounded-2xl bg-white shadow-2xl ${widthClassName}`}>
        <div className="px-6 pt-6 pb-0 shrink-0">
          <div className="flex items-start justify-between gap-3">
            <div>
              <h2 className="text-lg font-bold text-slate-800">{title}</h2>
              {description ? (
                <p className="text-sm text-slate-500 mt-1">{description}</p>
              ) : null}
            </div>
            <button
              type="button"
              className="text-sm font-medium text-slate-400 transition-colors hover:text-slate-600"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto px-6 pt-6 pb-6">{children}</div>
      </div>
    </div>
  )
}
